import script from "./PdRadioCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PdRadioCard.vue?vue&type=script&setup=true&lang=js"

import "./PdRadioCard.vue?vue&type=style&index=0&id=f60eeeb8&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f60eeeb8"]])

export default __exports__